import React, { FC } from 'react';
import styles from './PlayerHeader.module.scss';

interface PlayerActionsProps {
	title: string;
}

const PlayerHeader: FC<PlayerActionsProps> = ({ title }): JSX.Element => {
	return (
		<section className={styles.PlayerHeader}>
			<div>{title}</div>
			<div></div>
			<div>
				{/* <Button primary title='Add real bonus' small className={styles.Button} />
				<Button primary title='Find similar' small className={styles.Button} /> */}
				{/*<Button danger title='Block' className={styles.Button} />*/}
				{/*<Button primary title='Enable' className={styles.Button} />*/}
			</div>
		</section>
	);
};

export { PlayerHeader };
